// @greenlight-spec: 28-it-dashboard-ui.md
import { Link } from 'react-router-dom';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Eyebrow } from '@/components/greenlight/Eyebrow';

interface PlaceholderProps {
  eyebrow: string;
  title: string;
  intent: string;
  contentTickets?: readonly string[];
}

export function Placeholder({ eyebrow, title, intent, contentTickets }: PlaceholderProps) {
  return (
    <div className="space-y-6" data-testid="placeholder-page">
      <div>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1 className="text-2xl md:text-[28px] font-semibold tracking-[-0.02em]">{title}</h1>
        <p className="text-muted-foreground text-sm mt-1">{intent}</p>
      </div>
      <Alert>
        <AlertTitle>Content lands separately</AlertTitle>
        <AlertDescription>
          T-080 ships only the adaptive shell. Page content arrives with
          {contentTickets?.length ? ` ${contentTickets.join(', ')}` : ' T-081…T-089'}.
        </AlertDescription>
      </Alert>
    </div>
  );
}

export { InstallPage } from './InstallPage';

export function NotFoundPage() {
  return (
    <div className="space-y-4 text-center py-16" data-testid="not-found">
      <Eyebrow>404</Eyebrow>
      <h1 className="text-2xl font-semibold tracking-[-0.02em]">Page not found</h1>
      <p className="text-muted-foreground text-sm">That route is not part of the Greenlight UI.</p>
      <p>
        <Link to="/apps" className="text-link underline underline-offset-4">
          Go to Apps
        </Link>
      </p>
    </div>
  );
}
